import React from 'react'
import { Tabs } from '@surecompanies/core_components'
import { useRouterContext } from 'components/RouterContext'
import { PLAN_OVERRIDE_TABS, PlanOverrideTabKey } from '../constants'
import { planOverridesTabPath } from '../paths'

const { TabPane } = Tabs

interface Props {
  activeTab: PlanOverrideTabKey
}

const GLOBAL_FILTER_KEYS = ['state', 'issuerId', 'hiosPlanId'] as const

export default function PlanOverridesTabsHeader({ activeTab }: Props) {
  const { router, location } = useRouterContext()

  const handleChange = (key: string) => {
    const current = (location?.query ?? {}) as Record<string, string>
    const preserved: Record<string, string> = {}
    for (const k of GLOBAL_FILTER_KEYS) {
      if (current[k]) preserved[k] = current[k]
    }
    router.push({ pathname: planOverridesTabPath(key), query: preserved })
  }

  return (
    <Tabs activeKey={activeTab} onChange={handleChange} type="line">
      {PLAN_OVERRIDE_TABS.map((tab) => (
        <TabPane key={tab.key} tab={tab.label} />
      ))}
    </Tabs>
  )
}
